import { createSelector } from 'reselect';

import { GROUPS } from '../common/filters';
import { countryCodeIsVietnam } from '../common/helpers/countryCodeHelper';
import { getJobs } from './entities';
import { getSessionCompanyCountryCode } from './session';

export const getIsJobCopyDisabled = state =>
  countryCodeIsVietnam(getSessionCompanyCountryCode(state));

export const getCurrentCompanyJobIds = state => state.jobs.companyJobs.value;
export const getCurrentCompanyJobsLoading = state =>
  state.jobs.companyJobs.loading;

export const getCurrentCompanyJobs = createSelector(
  [getCurrentCompanyJobIds, getJobs],
  (ids, jobs) => ids.map(id => jobs[id])
);

export function getTalentHuntJobs(jobs = []) {
  return jobs
    .filter(job =>
      job.links.groups.some(
        group =>
          group.id === GROUPS.talentSearchCompany.id &&
          group.GroupJob.status === 'APPROVED'
      )
    )
    .filter(job => job.status === 'OPEN');
}

export function getNonTalentHuntJobs(jobs = []) {
  return jobs.filter(
    job =>
      !job.links.groups.some(
        group => group.id === GROUPS.talentSearchCompany.id
      )
  );
}
